import _ from 'lodash';
import cssUtil from 'gw-portals-util-js/CssUtil';

import styles from './typeahead-hashed.scss';
import typeaheadTemplate from 'text!./templates/typeahead.html';
import { DefaultMatchDirective } from './matchContentDirectives/Injector';

var DEFAULT_DEBOUNCE_MS = 50;
export default ['$q', '$timeout', function ($q, $timeout) {
    var debounce = function debounce(fn, debounceTime) {
        var prevDeferred = void 0;
        var timeoutPromise = void 0;
        return function () {
            var _this = this;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            if (timeoutPromise) {
                $timeout.cancel(timeoutPromise);
            }

            if (prevDeferred) {
                prevDeferred.resolve([]); // Don't leave memory leaks
            }

            var deferred = $q.defer();
            prevDeferred = deferred;

            timeoutPromise = $timeout(function () {
                $q.resolve(fn.apply(_this, args)).then(function (result) {
                    return deferred.resolve(result);
                }, function (err) {
                    return deferred.reject(err);
                });
            }, debounceTime);

            return deferred.promise;
        };
    };

    return {
        restrict: 'E',
        template: cssUtil.hashTemplate(typeaheadTemplate, styles),
        controller: ['$scope', '$element', function ($scope, $element) {
            // Controller exists to pass stuff to gw-typeahead-hook.
            // gw-typeahead-hook requires gw-typeahead, so the controller becomes available.
            this._getMatches = function () {
                return $scope._getMatches.apply($scope, arguments);
            };

            this._toString = function () {
                return $scope._toString.apply($scope, arguments);
            };

            this._selectDirective = function () {
                return $scope._selectDirective();
            };

            this._getElement = function () {
                return $element;
            };

            this._setLoading = function (loading) {
                $scope.$applyAsync('_loading = ' + String(Boolean(loading)));
            };

            this._setOpen = function (open) {
                $scope.$applyAsync('_open = ' + String(Boolean(open)));
            };

            this.isEditable = function () {
                return $scope.editable;
            };
        }],
        scope: {
            result: '=',
            editable: '<',
            definition: '<',
            placeholder: '@',
            debounceMs: '@'
        },
        link: function link($scope) {
            $scope.wipe = function () {
                $scope.selectedItem = '';
            };

            $scope.$watch('definition', function (definition) {
                if (!definition) {
                    // Do not set anything up if there's no definition
                    return;
                }

                $scope._selectDirective = function () {
                    return definition.directive || DefaultMatchDirective;
                };

                var knownResults = new Map();
                var updateResults = function updateResults(results) {
                    return results.forEach(function (result) {
                        return knownResults.set($scope._toString(result), result);
                    });
                };

                var debounceMs = parseFloat($scope.debounceMs) || DEFAULT_DEBOUNCE_MS;

                $scope._getMatches = debounce(_.memoize(function (userinput) {
                    // Memoize is there to not make extra requests for same userinput
                    if (knownResults.has(userinput)) {
                        return [knownResults.get(userinput)]; // Userinput matches one of the previously received values, no need to make any extra requests;
                    }

                    var results = definition.getMatches(userinput);
                    $q.resolve(results).then(updateResults);

                    return results;
                }), debounceMs);

                $scope._toString = function (item) {
                    if (!item) {
                        return '';
                    }

                    if (typeof item === 'string') {
                        return item;
                    }

                    return definition.toString(item);
                };

                $scope.selectedItem = $scope._toString($scope.result);
                $scope.$watch('selectedItem', function (selectedItem) {
                    if (selectedItem !== $scope._toString($scope.result)) {
                        // In some cases (e.g. initial render), we might receive a value matching the current item.
                        // Watch might be triggered, because toString(item) may be different from item depending on the typeahead definition.
                        // So this check safeguards against backpropagating string value where we have a perfectly suitable model.
                        $scope.result = selectedItem;
                    }
                });
            });

            $scope.$watch('result', function (result) {
                if (result !== undefined) {
                    $scope.selectedItem = $scope._toString(result);
                }
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/typeahead/TypeaheadPublic.js
// module id = 1183
// module chunks = 0